import {
  PROD_DEFAULT_LANGUAGE,
  PROD_SUPPORTED_LANGUAGES as SUPPORTED_LANGUAGES,
} from 'state/intl/constants';
import { LANGUAGES } from 'state/intl/types';
import { region } from 'utils/environment';

export function findSupportedLanguage(requestedLanguage: string): LANGUAGES {
  return SUPPORTED_LANGUAGES[requestedLanguage] || PROD_DEFAULT_LANGUAGE[region];
}
